//
import Card from "./Card";
import Paper from "./Paper";
import Input from "./Input";
import Table from "./Table";
import Button from "./Button";
import Tooltip from "./Tooltip";
import Backdrop from "./Backdrop";
import Typography from "./Typography";
import Autocomplete from "./Autocomplete";
import List from "./List";
import ListItemButton from "./ListItemButton";
import Breadcrumbs from "./Breadcrumbs";
import Tabs from "./Tabs";
import Modal from "./Modal";
import RadioGroup from "./RadioGroup";
import FormLabel from "./FormLabel";

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
	return Object.assign(
		Card(theme),
		Table(theme),
		Input(theme),
		Paper(theme),
		Button(theme),
		Tooltip(theme),
		Backdrop(theme),
		Typography(theme),
		Autocomplete(theme),
		List(theme),
		ListItemButton(theme),
		Breadcrumbs(theme),
		Tabs(theme),
		Modal(theme),
		RadioGroup(theme),
		FormLabel(theme),
	);
}
